<app-banner-app [retroSelected]="true"></app-banner-app>
<br><br><br><br><br><br>

<div class="container">
    <br><br>
    <div class="row">
        <div class="col-sm-6 col-md-5 offset-md-2 col-lg-6 offset-lg-0">
            <div class="aliniacionTexto">
                <div class="aliniacionTexto">
                    <img class="styleImage img-responsive" src="./../../assets/img/Candado.png" />
                </div>
            </div>
        </div>

        <div class="col">
            <div class="container" style="text-align: center;">
                <span class="tipografiaCard">Verifica tu número de contacto</span><br>
                <span class="textoDetalleTipografia">Necesitamos asegurarnos que realmente eres tú.<br>
                    Te enviaremos un código de verificación a través<br>
                    de un mensaje de texto.
                    <br><br>
                    Por favor selecciona tu número de celular actual:
                </span><br><br>
            </div>

            <div style="padding-left: 70px;">
                <ul style="list-style-type: none;">
                    <li>
                        <div class="form-check" style="padding-bottom: 7px;">
                            <input class="form-check-input" type="radio" name="rbtOption" value="Numero1"
                            style="border-color: #0033A0;">
                            <label class="form-check-label tipValorTotal" for="rbt">
                                xxx xxxx569
                            </label>
                        </div>

                        <div class="form-check" style="padding-bottom: 7px;">
                            <input class="form-check-input" type="radio" name="rbtOption" value="numero2"
                            style="border-color: #0033A0;">
                            <label class="form-check-label tipValorTotal" for="rbtNumero2">
                                xxx xxxx785
                            </label>
                            <br>
                        </div>
                    </li>

                    <div class="form-check">
                        <input class="form-check-input" type="radio" name="rbtOption" value="NoReconozco"
                        style="border-color: #0033A0;">
                        <label class="form-check-label tipValorTotal" for="rbtNoNumero">
                            No reconozco mi número
                        </label>
                        <br>
                    </div>
                </ul>
            </div>
            <br><br>

            <div style="width: 70%;" class="container">
                <button class="btn btn-primary w-100 py-2 botonContinuar" type="submit">Continuar</button>
            </div>
        </div>
    </div>

</div>

<br><br><br>
<app-footer-app></app-footer-app>